/*eslint-disable*/ export const messages = JSON.parse("{\"pill.aria.openFilter\":[\"Avaa suodatin\"],\"pill.aria.removeFilter\":[\"Tyhjennä suodatin \",[\"label\"]]}");
//# sourceMappingURL=messages.mjs.map